<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 600 80"
    preserveAspectRatio="xMinYMid meet"
    class="fill-flax-smoke-900"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- PRADEEP KISHOR scaled to full width -->
    <text
      x="0"
      y="50"
      font-size="50"
      font-family="Inter, Arial, sans-serif"
      font-weight="560"
      letter-spacing="0"
      textLength="600"
      lengthAdjust="spacingAndGlyphs"
    >
      PRADEEP KISHOR
    </text>

    <!-- Subtitle -->
      <text
      x="0"
      y="75"
      font-size="18"
      font-family="Inter, Arial, sans-serif"
      font-weight="380"
      fill="#8c8c8c"
      textLength="250"
      lengthAdjust="spacingAndGlyphs"
    >
      UI / UX DESIGNER
    </text>
  </svg>
</template>
